export default "__VITE_ASSET__sdyFfaet__"